import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=f97a19e4&"
import script from "./logout.vue?vue&type=script&lang=ts&"
export * from "./logout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports